import { render, staticRenderFns } from "./overall-stats.vue?vue&type=template&id=18b0da2f&scoped=true&"
import script from "./overall-stats.vue?vue&type=script&lang=js&"
export * from "./overall-stats.vue?vue&type=script&lang=js&"
import style0 from "./overall-stats.vue?vue&type=style&index=0&id=18b0da2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b0da2f",
  null
  
)

export default component.exports